import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = { class: "i-tabs__item" };
var _hoisted_2 = ["aria-label"];
import { StatusClassNames } from "../../../types/StatusClassNames";
import Sprite from "../../../components/Sprite.vue";
import { computed } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ViewModeSwitchButton',
    props: /*@__PURE__*/ _mergeModels({
        mode: { type: String, required: true },
    }, {
        "modelValue": {},
        "modelModifiers": {},
    }),
    emits: /*@__PURE__*/ _mergeModels(['click'], ["update:modelValue"]),
    setup: function (__props) {
        var props = __props;
        var activeMode = _useModel(__props, "modelValue");
        var title = computed(function () { return props.mode === 'more' ? 'Мельче' : 'Крупнее'; });
        return function (_ctx, _cache) {
            var _a;
            return (_openBlock(), _createElementBlock("li", _hoisted_1, [
                _createElementVNode("button", {
                    class: _normalizeClass(["i-tabs__btn", (_a = {}, _a[_unref(StatusClassNames).active] = __props.mode === activeMode.value, _a)]),
                    onClick: _cache[0] || (_cache[0] = function ($event) { return (_ctx.$emit('click')); }),
                    "aria-label": title.value
                }, [
                    _createVNode(Sprite, {
                        name: "grid-".concat(__props.mode),
                        size: "24"
                    }, null, 8 /* PROPS */, ["name"])
                ], 10 /* CLASS, PROPS */, _hoisted_2)
            ]));
        };
    }
});
